<template>
  <div>
    <AlertWraper
      :content="content"
      :type="content_type"
    />
    <div class="">
      <h2>Dados da campanha</h2>
      <!-- begin: OTHER campaign types upsert -->
      <p>
        <strong>Nome:</strong> {{ campaign?.name }}<br/>
        <strong>Status:</strong> {{ campaign.status | formatCampaignStatus }}<br/>
        <strong>Tipo:</strong> {{ campaign.type | formatCampaignType }}<br/>
        <strong>Valor:</strong> {{ campaign.amount / 100 | formatMoney }}<br/>
        <strong>Valor MGID:</strong> {{ platformAmount / 100 | formatMoney }}<br/>
        <strong>Data de início:</strong> {{ campaign.start_date | formatDate('DD/MM/YYYY') }}<br/>
        <strong>Data de término:</strong> {{ campaign.end_date | formatDate('DD/MM/YYYY') }}<br/>
        <strong>Verba diária MGID:</strong> {{ platformAmount / durationInDays / 100 | formatMoney }}<br/>
        <strong>Meta de CPC:</strong> {{ campaign.cpc_target_amount / 100 | formatMoney }}<br/>
        <strong>Meta de CPC MGID:</strong> {{ (campaign.cpc_target_amount * (1 - (this.campaign.retention / 100))) / 100 | formatMoney }}
      </p>
      <hr>
      <div class="mt-8 mb-8">
        <h2> Cadastrar campanha na plataforma {{ campaign.platform }} </h2>
        <p>Finalize o cadastro da campanha na plataforma do parceiro e, por fim, inclua o ID da campanha e criativos abaixo.</p>
        <div class="text-center mt-5">
          <a
            href="https://ads.mgid.com/campaigns"
            class="btn btn-sm btn-primary"
            target="_blank"
          >
            Cadastrar
          </a>
        </div>
      </div>
      <!-- end: OTHER campaign types upsert -->

      <hr>
      <div class="mt-8">
        <h2> Vincular Campanha </h2>
        <form @submit.prevent="submit" class="mt-2">
          <div class="form-group mb-3 col-lg-4">
            <label class="form-label text-start">Insira o ID da campanha na plataforma {{ campaign.platform }}</label>
            <input type="text" class="form-control w-50" placeholder="Ex.: 12345678 " v-model.trim="form.platform_id" />
          </div>

          <div class="form-group mb-3 mt-8">
            <h2> Vincular Criativos </h2>
            <p class="col-lg-4 form-label text-start">Insira o ID dos criativos/anúncios criados na plataforma {{ campaign.platform }}</p>
            <div class="mb-4" v-for="(creative, index) in campaign.creatives.creatives" :key="index">
              <img :src="creative.file" alt="" width="200">
              <div class="row d-flex col-lg-8">
                <span class=""> <b>Criativo:</b> {{ creative.name }}</span>
                <span class=""><b>Url:</b> {{ creative.url }}</span>
                <span class=""> <b>Formato:</b> {{ creative.format | formatCreativeFormat }} </span>
                <span class=""> <b>Título:</b> {{ creative.headline }} </span>
                <span class=""> <b>Corpo do texto:</b> {{ creative.body_text }} </span>
                <span class=""> <b>Tamanho:</b> {{ creative.layout }}</span>
              </div>
              <div class="col-lg-4 mt-4">
                <input type="text" class="form-control w-50" placeholder="Ex.: 12345678 " v-model.trim="form.creatives[index].platform_id" />
              </div>
            </div>
          </div>
          <div class="mt-3 text-center">
            <Button
              type="submit"
              class="btn btn-primary"
              :loading="loader"
            >
              Enviar
            </Button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import CampaignsService from '@/modules/campaigns/services/campaigns-service'
import { parseErrorResponseToArray } from '@/utils'

import AlertWraper from '@/components/common/Alert/AlertWraper'
import Button from '@/components/common/Button/Button'
import moment from 'moment'

export default {
  name: 'UpsertMgidCampaignForm',
  components: {
    Button,
    AlertWraper
  },
  props: ['campaign'],
  data () {
    return {
      content: null,
      content_type: 'error',
      loader: false,
      form: {
        platform_id: '',
        creatives: []
      }
    }
  },
  created () {
    this.form.platform_id = this.campaign.platform_id
    this.campaign.creatives.creatives.filter(creative => {
      this.form.creatives.push({ id: creative?.id, platform_id: creative?.platform_id ?? '' })
    })
  },
  computed: {
    /**
     * Duration in days of campaign (add 1 to count fo the start day)
     */
    durationInDays () {
      return moment(this.campaign.end_date).endOf('day').diff(moment(this.campaign.start_date).startOf('day'), 'days') + 1
    },
    /**
     * Get platform amount with retention applied
     */
    platformAmount () {
      return this.campaign.amount * (1 - (this.campaign.retention / 100))
    }
  },
  methods: {
    /**
     * Submit
     */
    async submit () {
      this.loader = true
      this.content = null
      try {
        const campaign = await CampaignsService.upsertNativeContextualPushCampaignOnPlatform({
          campaignId: this.campaign.id,
          platformId: this.form.platform_id,
          creatives: this.form.creatives
        })
        this.$emit('upserted', campaign)
      } catch (error) {
        this.content = parseErrorResponseToArray(error)
      }
      this.loader = false
    }
  }
}
</script>
